import React from 'react';

// GLOBAL COMPONENTS
import NoResults from 'core/tools/NoResults';

// LOCAL COMPONENTS
import TableDnD from '../desktop/TableDnD';

// HELPERS
import { useListData } from 'helpers/getListData';

// MAIN COMPONENT
export default function DnDContainer(props) {
  const {
    loading, //
    result: data = []
  } = Object.assign(useListData() || {}, props);

  return data?.length ? (
    <TableDnD {...props} />
  ) : (
    <NoResults icon={loading ? 'clock' : 'mood-bad'} className="flex-grow-1 d-flex flex-column justify-content-center">
      {loading ? 'Loading...' : 'No Results Found'}
    </NoResults>
  );
}
